import { SendRelatedContactTextProps } from './index';
import { Step } from 'pages/AutomationEngine/types';
import {
  AddErrorMessage,
  MessageDictionary,
} from 'pages/AutomationEngine/messageDictionary';
import { displayNameToOptionWithDeleted } from 'services/helpers';

import { CreateAutomationMessageProps } from '../SendText/types';

type ForApiReturn = {
  text: { id: string };
  sendToContactField: string;
};

const forApi = (
  step: Step & { details: SendRelatedContactTextProps['values'] }
) => {
  const orgDetails = { ...step.details };
  const api: ForApiReturn = {
    text: { id: orgDetails?.textObject?.id! },
    sendToContactField: orgDetails.sendToContactField?.value,
  };

  return { details: api };
};

type ForFlowApiObject = {
  sendFromOwner: boolean;
  sendToContactField: any;
  text: CreateAutomationMessageProps;
};

const forFlow = (
  apiObject: ForFlowApiObject,
  _addErrorMessage: AddErrorMessage,
  messageDictionary: MessageDictionary
) => {
  const { sendFromOwner, sendToContactField, text } = apiObject;

  return {
    sendFromOwner,
    textObject: text,
    sendToContactField: displayNameToOptionWithDeleted(
      sendToContactField,
      messageDictionary.deleted
    ),
  };
};
export const sendRelatedContactTextDTO = {
  forApi,
  forFlow,
};
